module.exports = __webpack_public_path__ + "static/media/25th Anniversary.3ea5877e.png";